<p *ngIf="Groups.length <= 0">No groups available</p>
<ul class="list-group">
  <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-action" *ngFor="let group of Groups" (click)="pickGroup(group)">
    {{group.name}} 
    <span *ngIf="tokensEnabled && hasLoadedTokens && !shouldBuyTokens(group)" class="badge badge-primary badge-pill" alt="Tokens Remaining" title="Tokens Remaining">{{getGroupTokensRemaining(group)}}</span>
    <dac-buy-item-button *ngIf="tokensEnabled && hasLoadedTokens && shouldBuyTokens(group)" (click)="triggerBuy($event)" 
        [item]="group"></dac-buy-item-button>
    <span *ngIf="!tokensEnabled" class="badge badge-primary badge-pill btn btn-sm btn-primary" alt="Add As Assignment"
      title="Add As Assignment">Add
    </span>
  </li>
</ul>


// WEBPACK FOOTER //
// ./src/app/shared/assessment-group-list/assessment-group-list.component.html